/**
 * The H2 navigation.
 *
 * Every item is a real link now (the last "Coming soon" went with the Staff
 * page, 2026-09-13). The disabled-item branch stays for the next thing that
 * is announced before it is built. There is no Question Bank item: Brian (2026-09-12) — the
 * questions live inside the session, on the section's Interaction items panel,
 * not on the main dashboard. Showing what is coming beats an empty sidebar: it tells a
 * coordinator the shape of the finished tool and makes "not built yet" explicit
 * rather than looking like something failed to load.
 *
 * Accessibility: disabled items carry a real `disabled` attribute as well as
 * the words. Greying them out alone would be invisible to a screen reader and
 * marginal for anyone with low vision (Decision #18).
 */
import { NavLink } from 'react-router-dom';

const SECTIONS = [
  {
    key: 'sections',
    label: 'Course sections',
    description: 'Build CCL-coded sections and their schedules',
    to: '/sections',
  },
  {
    key: 'sessions',
    label: 'Sessions',
    description: 'Open a class and show its check-in code',
    to: '/sessions',
  },
  {
    key: 'skills',
    label: 'Skill sheets',
    description: 'The station checksheets, marked in class',
    to: '/skill-sheets',
  },
  {
    key: 'catalog',
    label: 'Catalog',
    description: 'Courses, hours and how long they last',
    to: '/catalog',
  },
  {
    key: 'personnel',
    label: 'System Personnel',
    description: 'Everyone, with cert number and expiry',
    to: '/personnel',
  },
  {
    key: 'tracker',
    label: 'Tracker',
    description: 'Completions and hours by agency',
    to: '/tracker',
  },
  {
    key: 'compliance',
    label: 'Compliance',
    description: 'Who must hold what, and who is behind',
    to: '/compliance',
  },
  { key: 'staff', label: 'Staff', description: 'Who can sign in; invite someone', to: '/staff' },
];

export function Nav() {
  return (
    <nav aria-label="Main">
      <ul className="nav">
        {SECTIONS.map((section) => (
          <li key={section.key}>
            {section.to ? (
              <NavLink
                to={section.to}
                className={({ isActive }) =>
                  isActive ? 'nav__item nav__item--active' : 'nav__item'
                }
              >
                <span className="nav__label">{section.label}</span>
                <span className="nav__desc">{section.description}</span>
              </NavLink>
            ) : (
              <button type="button" className="nav__item" disabled aria-disabled="true">
                <span className="nav__label">{section.label}</span>
                <span className="nav__desc">{section.description}</span>
                <span className="nav__badge">Coming soon</span>
              </button>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default Nav;
